import Constants from '../Constants.js';
const initialState = {
  profile: null,
  idToken: null,
  loading: false,
  error: false,
  message: null,
  requires2FA: false,
  requires2FAEnroll: false,
  oneTimeCodes: null
};

// eslint-disable-next-line default-param-last
function auth(state = initialState, action) {
  switch (action.type) {
    case Constants.AUTH_VERIFYING:
    case Constants.AUTH_ACTIVATING_ACCOUNT:
    case Constants.AUTH_LOGGING_IN:
    case Constants.AUTH_SUBMITTING_LOGIN_CODE:
    case Constants.AUTH_REQUESTING_LOGIN_CODE:
      return {
        ...state,
        profile: null,
        idToken: null,
        credentials: action.credentials,
        message: null,
        loading: action.type,
        renewing: false,
        error: false,
        requires2FA: state.requires2FA,
        info: state.info
      };
    case Constants.AUTH_LOGGING_IN_DEVICE_CODE:
      {
        return {
          ...state,
          loading: action.type,
          requires2FA: state.requires2FA,
          info: state.info
        };
      }
    case Constants.AUTH_LOGGING_IN_WITH_2FA:
      return {
        ...state,
        credentials: action.credentials,
        loading: action.type,
        requires2FA: state.requires2FA,
        info: state.info,
        error: false,
        renewing: false,
        message: null
      };
    case Constants.AUTH_CHANGING_PASSWORD:
    case Constants.AUTH_LOGGING_OUT:
    case Constants.AUTH_SENDING_FORGOT_PASSWORD:
    case Constants.AUTH_RESETTING_PASSWORD:
      return {
        profile: state.profile,
        idToken: state.idToken,
        credentials: state.credentials,
        message: null,
        loading: action.type,
        renewing: false,
        error: false
      };
    case Constants.AUTH_CHANGE_PASSWORD_FAILED:
    case Constants.AUTH_LOG_OUT_FAILED:
    case Constants.AUTH_SEND_FORGOT_PASSWORD_FAILED:
    case Constants.AUTH_RESET_PASSWORD_FAILED:
    case Constants.AUTH_REQUEST_LOGIN_CODE_FAILED:
    case Constants.AUTH_SUBMIT_LOGIN_CODE_FAILED:
      return {
        profile: state.profile,
        idToken: state.idToken,
        credentials: state.credentials,
        message: action.message,
        loading: action.type,
        renewing: false,
        error: true,
        exception: action.exception
      };
    case Constants.AUTH_ACTIVATED_ACCOUNT:
      return {
        profile: state.profile,
        idToken: null,
        credentials: action.credentials,
        message: null,
        loading: action.type,
        renewing: false,
        error: false
      };
    case Constants.AUTH_SENT_FORGOT_PASSWORD:
      return {
        profile: state.profile,
        idToken: state.idToken,
        credentials: state.credentials,
        message: null,
        loading: action.type,
        renewing: false,
        error: false,
        forgotSent: true
      };
    case Constants.AUTH_REQUESTED_LOGIN_CODE:
      return {
        ...state,
        profile: state.profile,
        idToken: state.idToken,
        credentials: state.credentials,
        message: null,
        loading: action.type,
        renewing: false,
        error: false,
        loginCodeSent: true
      };
    case Constants.AUTH_CHANGED_PASSWORD:
    case Constants.AUTH_RESET_PASSWORD:
      return {
        profile: state.profile,
        idToken: state.idToken,
        credentials: state.credentials,
        message: null,
        loading: action.type,
        renewing: false,
        error: false,
        changedPassword: true
      };
    case Constants.AUTH_REQUIRES_2FA:
      return {
        ...state,
        profile: action.profile,
        idToken: action.idToken,
        credentials: null,
        info: action.info,
        message: null,
        loading: false,
        renewing: false,
        error: false,
        requires2FA: true,
        requires2FAEnroll: false
      };
    case Constants.AUTH_REQUIRES_2FA_DEVICE_CODE:
      {
        return {
          ...state,
          idToken: action.idToken,
          info: action.info,
          credentials: null,
          message: null,
          loading: false,
          renewing: false,
          error: false,
          requires2FA: true,
          requires2FAEnroll: false,
          deviceAccessTokenRequest: {
            requires2FA: true,
            loading: false,
            profile: action.profile,
            idToken: action.idToken,
            info: action.info
          }
        };
      }
    case Constants.AUTH_REQUIRES_2FA_ENROLL:
      return {
        ...state,
        profile: action.profile,
        idToken: action.idToken,
        credentials: null,
        info: action.info,
        message: null,
        loading: false,
        renewing: false,
        error: false,
        requires2FA: true,
        requires2FAEnroll: true
      };
    case Constants.AUTH_TWO_FACTOR_PREACTIVATE_SUCCESS:
      return {
        ...state,
        error: false,
        profile: action.profile
      };
    case Constants.AUTH_TWO_FACTOR_PREACTIVATE_ERROR:
      return {
        ...state,
        error: true,
        message: action.message
      };
    case Constants.AUTH_TWO_FACTOR_ACTIVATE_SUCCESS:
      return {
        ...state,
        error: false,
        profile: action.profile,
        idToken: action.idToken,
        oneTimeCodes: action.oneTimeCodes
      };
    case Constants.AUTH_TWO_FACTOR_ACTIVATE_ERROR:
      return {
        ...state,
        error: true,
        message: action.message
      };
    case Constants.TWO_FACTOR_GENERATE_CODE:
      return {
        ...state,
        info: action.info
      };
    case Constants.TWO_FACTOR_PREACTIVATE_METHOD:
      return {
        ...state,
        info: action.activationData?.message
      };
    case Constants.AUTH_LOGGED_IN:
      return {
        ...state,
        profile: action.profile,
        idToken: action.idToken,
        credentials: null,
        message: null,
        info: null,
        loading: false,
        renewing: false,
        error: false,
        requires2FA: false,
        requires2FAEnroll: false,
        deviceCodeRequest: undefined,
        deviceAccessTokenRequest: undefined,
        deviceLoginSuccess: !!action.userCode
      };
    case Constants.AUTH_LOGGED_IN_DEVICE_CODE:
      return {
        ...state,
        deviceAccessTokenRequest: {
          loading: false,
          success: true,
          error: undefined,
          result: action.result
        }
      };
    case Constants.AUTH_LOGGED_OUT:
    case Constants.AUTH_VERIFY_FAILED:
    case Constants.AUTH_RESET_2FA_VERIFY:
      return {
        profile: null,
        idToken: null,
        credentials: null,
        message: null,
        loading: false,
        renewing: false,
        error: false
      };
    case Constants.AUTH_ACTIVATE_ACCOUNT_FAILED:
    case Constants.AUTH_LOGIN_FAILED:
      return {
        profile: null,
        idToken: null,
        credentials: action.credentials,
        message: action.message,
        loading: false,
        renewing: false,
        error: true,
        exception: action.exception
      };
    case Constants.AUTH_LOGIN_WITH_2FA_FAILED:
      if (action.message === 'jwt expired') {
        return {
          profile: null,
          idToken: null,
          credentials: null,
          message: 'Session expired. Please sign in again.',
          loading: false,
          renewing: false,
          error: true,
          requires2FA: null,
          info: null
        };
      }
      return {
        profile: state.profile,
        idToken: state.idToken,
        credentials: action.credentials,
        message: action.message,
        loading: false,
        renewing: false,
        error: true,
        requires2FA: true,
        info: state.info
      };
    case Constants.AUTH_RENEWING:
      return {
        ...state,
        renewing: true
      };
    case Constants.AUTH_RENEWED:
      return {
        profile: action.profile,
        idToken: action.idToken,
        credentials: null,
        message: null,
        renewing: false,
        loading: false,
        error: false
      };
    case Constants.AUTH_UPDATE_PROFILE:
      return {
        ...state,
        profile: action.profile
      };
    case Constants.AUTH_REQUESTING_DEVICE_CODE:
    case Constants.AUTH_CONFIRMING_DEVICE_CODE:
      return {
        ...state,
        deviceCodeRequest: {
          loading: action.type
        }
      };
    case Constants.AUTH_REQUEST_DEVICE_CODE_FAILED:
    case Constants.AUTH_CONFIRM_DEVICE_CODE_FAILED:
      return {
        ...state,
        deviceCodeRequest: {
          loading: false,
          error: {
            message: action.message,
            exception: action.exception
          }
        }
      };
    case Constants.AUTH_REQUESTED_DEVICE_CODE:
      {
        /* eslint-disable camelcase */
        const {
          user_code,
          device_code,
          expires_in,
          interval,
          authorization_uri,
          authorization_uri_complete
        } = action;
        return {
          ...state,
          deviceCodeRequest: {
            loading: false,
            error: undefined,
            userCode: user_code,
            deviceCode: device_code,
            expiresIn: expires_in,
            authorizationUri: authorization_uri,
            authorizationUriComplete: authorization_uri_complete,
            /* eslint-enable camelcase */
            interval
          },
          deviceAccessTokenRequest: undefined
        };
      }
    case Constants.AUTH_CONFIRMED_DEVICE_CODE:
      {
        return {
          ...state,
          deviceCodeRequest: {
            ...state.deviceCodeRequest,
            confirmed: true
          },
          deviceAccessTokenRequest: undefined
        };
      }
    case Constants.AUTH_REQUESTING_DEVICE_ACCESS_TOKEN:
      {
        return {
          ...state,
          deviceAccessTokenRequest: {
            loading: action.type
          }
        };
      }
    case Constants.AUTH_REQUEST_DEVICE_ACCESS_TOKEN_FAILED:
      {
        return {
          ...state,
          deviceAccessTokenRequest: {
            loading: false,
            error: {
              message: action.message,
              exception: action.exception
            }
          }
        };
      }
    case Constants.AUTH_SET_USER_CODE:
      return {
        ...state,
        deviceAccessTokenRequest: {
          userCode: action.userCode
        }
      };
    case Constants.AUTH_CLEAR_USER_CODE:
      return {
        ...state,
        deviceAccessTokenRequest: undefined
      };
    default:
      return state;
  }
}
export default auth;